import { render, staticRenderFns } from "./OrderAddButton.vue?vue&type=template&id=0cd3caa8&scoped=true&"
import script from "./OrderAddButton.vue?vue&type=script&lang=js&"
export * from "./OrderAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3caa8",
  null
  
)

export default component.exports